import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 20px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  margin: 0 1rem;
`;

export const Control = styled.button<{ active?: boolean }>`
  ${({ active = true }) => css`
    padding-block: 0;
    padding-inline: 0;
    border-radius: 10px;
    padding: 10px;
    border: none;
    background: white;
    margin: 0;
    cursor: ${active ? 'pointer' : 'default'};
    &:hover {
      background: ${active ? '#eeeeee' : 'none'};
    }
    &:active {
      background: ${active ? '#d9d9d9' : 'none'};
    }
  `}
`;

export const Icon = styled.button`
  border-radius: 10px;
  padding: 10px;
  background-color: transparent;
  border-color: #ccc;
`;

export const ListBoxContainer = styled.div`
  width: 100%;
`;

export const ListBox = styled.div`
  width: 100%;
  height: calc(100vh - 505px);
  border: 1px solid #ccc;
  border-radius: 10px;
  overflow-y: auto;
`;

export const Item = styled.div<{ isSelected?: boolean }>`
  cursor: pointer;
  text-align: start;
  background-color: ${(props) =>
    props.isSelected ? '#e0e0e0' : 'transparent'};

  &:hover {
    background-color: ${(props) => (props.isSelected ? '#e0e0e0' : '#f0f0f0')};
  }
`;

export const BottomControlsContainer = styled.div`
  width: 100%;
  margin-top: 10px;
`;
